import React from "react";
import Background from "../../utils/Background/Background.component";

import "./Initializing.component.scss";

export const Initializing = props => (
    <div id="Initializing">
        <Background />
    </div>
);
